"use strict";
function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/rxjs/util/identity.js
// module id = ../../../../rxjs/util/identity.js
// module chunks = 4